export default {
  login (context, user, password) {
    var body = {
      client_id: context.$store.state.config.client_id,
      client_secret: context.$store.state.config.client_secret,
      username: user,
      password: password,
      scope: '*',
      grant_type: 'password'
    }
    context.$http.post(context.$store.state.config.authURL + '/token', body).then((response) => {
      context.$store.dispatch('SET_TOKEN', response.body)
      context.$store.dispatch('SET_LOGGED', true)
      this.userData(context)
    }, (response) => {
      context.errorLogin = response.body.message
      context.inProgress = false
    })
  },
  loginToken (context, token) {
    context.$store.dispatch('SET_TOKEN', {access_token: token})
    context.$store.dispatch('SET_LOGGED', true)
    this.userData(context)
  },
  userData (context) {
    context.$http.get(context.$store.state.config.apiURL + '/user').then((response) => {
      if (parseInt(response.body.active) === 1) {
        context.$store.dispatch('SET_USER', response.body)
        // context.$http.get(context.$store.state.config.apiURL + '/notifications').then((response) => {
        //   context.$store.dispatch('SET_NOTIFICATIONS', response.body.notifications)
        //   context.$store.dispatch('SET_COUNTERS', response.body.counters)
        //   context.$store.dispatch('SET_ALERT', true)
        window.location.href = './'
        // }, (response) => {
        //   // error callback
        // })
      } else {
        context.errorLogin = 'User is inactive'
        context.inProgress = false
        context.$store.state.config.user = 0
        this.logout(context, false)
      }
    }, (response) => {
      // error callback
    })
  },
  logged (context) {
    if (context.$store.state.config.logged) {
      return true
    } else {
      return false
    }
  },
  logout (context, redirect) {
    let level = null
    if (context.$store.state.config.logged) {
      level = context.$store.state.config.user.level
    }
    context.$store.state.config.logged = false
    // context.$store.state.config.user = null
    context.$store.state.config.token = null
    context.$store.state.config.show_alert = null
    context.$store.state.config.version = null
    context.$store.dispatch('SET_LOGGED', false)
    window.localStorage.clear()
    window.sessionStorage.clear()
    if (redirect) {
      if (parseInt(level) === 99) {
        window.location.href = 'https://ezlink.global/site'
      } else {
        window.location.href = './'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./client/auth/index.js